import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input, InputNumber, Select, DatePicker, message } from 'antd';
import Text from '../../../basicElement/Text';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import { getMatchOption, generateOptions } from '../../../shared/selectFn';
import Fetch from '../../../../common/Fetch';
import deepClone from '../../../shared/deepClone';
import format from '../../../shared/format';
import API_URL from '../../../../common/url';

const width = 240;
const paddingLeft = 19.891;
const longWidth = 700 + paddingLeft;
const { Option } = Select;
const { TextArea } = Input;
const Default = {
    0: '否',
    1: '是',
};

const defaultOption = generateOptions(Default, 'radio');

const formatToCascaderOption = data => {
    (data || []).forEach(item => {
        item.value = item.complaintConfigureId;
        item.label = item.optionValue;

        if (item.childList && item.childList.length > 0) {
            item.children = item.childList;
            formatToCascaderOption(item.children);
        }
    });
};

function addSuffixMoney(text) {
    return text ? `${format('money', text)}元` : '';
}

function UpdateView(props, context) {
    const { data, editable, onChange, calcCoBackMonthPlanAmount, caleCoInAccountPlanPercent } = props;
    const { investigation = {}, invInfo = {} } = data || {};
    const { configure } = context;
    const {
        COMPLAINT_POSITION = [],
        COMPLAINT_TYPE = [],
        CO_POSSIBILITY = [], // 可能行
        CO_REASON = [], // 原因
        CO_INVOICE_RATE = [], // CO发票税率
    } = configure || {};

    const handleChange = (value, key) => {
        switch (key) {
        case 'coHappenedPercent': {
            data[key] = value;
            data.coFuturePercent = typeof (value) === 'number' ? (100 - value).toFixed(2) : '';
            break;
        }
        case 'investigation': {
            const { value: id, text: name } = value;
            data[`${key}Id`] = id;
            data[`${key}Name`] = name;
            data.investigation = value;
                // data.invInfo = queryInvInfo(id)
            data.investigationSiteId = '';
            data.investigationSiteName = '';
            break;
        }
        case 'investigationSite': {
            const { value: id, text: name } = value;
            data[`${key}Id`] = id;
            data[`${key}Name`] = name;
            break;
        }
        case 'coReasonId' : {
            data[key] = value;
            if (value !== '12' || !value) {
                data.coReasonRemark = undefined;
            }
            break;
        }
        case 'haveDiscount' : {
            data[key] = value;
            if (value == '0' || !value) {
                data.discountPercent = undefined;
            }
            break;
        }
        case 'coAmountAgreement' : {
            data[key] = value;
            if (value == '0' || !value) {
                data.coFinalization = undefined;
                data.coIsSigningProcess = undefined;
                data.signingNode = undefined;
                data.coUploadCtms = undefined;
            }
            break;
        }
        case 'coFinalization' : {
            data[key] = value;
            if (value == '0' || !value) {
                data.coIsSigningProcess = undefined;
                data.signingNode = undefined;
                data.coUploadCtms = undefined;
            }
            break;
        }
        case 'coIsSigningProcess' : {
            data[key] = value;
            if (value == '0' || !value) {
                data.signingNode = undefined;
                data.coUploadCtms = undefined;
            }
            break;
        }
        case 'actualSignCompletedDate' : {
            data[key] = value;
            data.planSignCompletedDate = value;
            break;
        }
        case 'planCoAmount' : {
            data[key] = value;
            data.coInAccountPlanPercent = caleCoInAccountPlanPercent({
                ...data,
                planCoAmount: value,
            }, invInfo);
            data.coBackMonthPlanAmount = calcCoBackMonthPlanAmount(data, invInfo);
            break;
        }
        case 'coInvoiceRateId' : {
            data[key] = value;
            const coRateValue = (CO_INVOICE_RATE || []).filter(item => item.coTraceConfigureId == value)[0].operationType;
            data.coRate = Number(coRateValue || 6);
            data.coInAccountPlanPercent = caleCoInAccountPlanPercent({
                ...data,
            }, invInfo);
            data.coBackMonthPlanAmount = calcCoBackMonthPlanAmount(data, invInfo);
            break;
        }
        case 'coBackMonthPlanInvoiceAmount': {
            data[key] = value;
            data.coBackMonthPlanAmount = calcCoBackMonthPlanAmount(data, invInfo);
            break;
        }
        case 'coBackPmFinishPercent': {
            data[key] = value;
            data.coBackMonthPlanAmount = calcCoBackMonthPlanAmount(data, invInfo);
            break;
        }
        default: {
            data[key] = value;
            break;
        }
        }
        onChange(data, key);
    };

    const coPossibilityOption = CO_POSSIBILITY.map(i => <Option key={i.coTraceConfigureId}>{i.typeValue}</Option>);
    const coReasonOption = CO_REASON.map(i => <Option key={i.coTraceConfigureId}>{i.typeValue}</Option>);
    const coRateOption = CO_INVOICE_RATE.map(i => <Option key={i.coTraceConfigureId}>{i.typeValue}</Option>);
    const complaintPositionOption = deepClone(COMPLAINT_POSITION);
    formatToCascaderOption(complaintPositionOption);
    return (
        <div style={{ background: '#fafafa' }}>
            <div className="historyContractRecordUpdate">
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text asterisk colon>项目简称</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                data.investigationName
                                :
                                <SearchRetrieve
                                    keyword="investigationName"
                                    style={{ width: longWidth }}
                                    params={{ limit: 20, isPmInv: 'TRUE', noFinished: 'true' }}
                                    placeholder="输入名称检索"
                                    value={data.investigationName}
                                    url={API_URL.investigation.queryInvestigationByName}
                                    config={{ id: 'investigationId', name: 'investigationName' }}
                                    onChange={option => handleChange(option, 'investigation')}
                                />
                            }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>JDE主项目号</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.jdeMainCode }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>项目类型</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.investigationGlobalTypeName }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>项目分期</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.byStageNames }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>项目分类</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.typeName }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>业务线</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.lineOfBusinessString }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>执行业务线二级分类</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.secondLineNames }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>计收入确认方式</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.contractTypeName }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>PM</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.pmNameCodes }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>项目领域</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.investigationAreaName }
                        </Col>
                    </Col>

                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>疾病</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.diseaseName }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>领域leader</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.leaderNameCode }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>PML（包含大区总监）</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.pmlNameCodes }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>BD</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.bdNameCodes }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>CSA</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.csaNameCode }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>BA</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.baNameCodes }
                        </Col>
                    </Col>

                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>原合同额含税/人民币</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { addSuffixMoney(invInfo.investigationContractAmount) }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>合同随机例数</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.contractRandomPlanAmount }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>津石随机例数</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.jsRandomNum }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>津石实际入组例数</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.jsActualRandomNum }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>截止当月完工百分比</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { invInfo.cumulativeFinishPercent }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk colon>计划CO金额含税/人民币</Text>
                        </Col>
                        <Col span={13} offset={1}>
                            <InputNumber
                                allowClear
                                placeholder="请输入"
                                style={{ width }}
                                value={data.planCoAmount}
                                precision={2}
                                onChange={value => handleChange(value, 'planCoAmount')}
                            />
                        </Col>
                        <Col span={1}>元</Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk colon>CO发票税率</Text>
                        </Col>
                        <Col span={14} offset={1}>
                            <Select
                                // allowClear={true}
                                placeholder="请选择"
                                style={{ width }}
                                value={format('toString', data.coInvoiceRateId || 25)}
                                onChange={value => handleChange(value, 'coInvoiceRateId')}
                            >
                                {coRateOption}
                            </Select>
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk={data.contractTypeName == '开票'} colon>CO签回当月预计可开票金额</Text>
                        </Col>
                        <Col span={13} offset={1}>
                            <InputNumber
                                allowClear
                                placeholder="请输入"
                                style={{ width }}
                                value={data.coBackMonthPlanInvoiceAmount}
                                precision={2}
                                onChange={value => handleChange(value, 'coBackMonthPlanInvoiceAmount')}
                            />
                        </Col>
                        <Col span={1}>元</Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk colon>CO可能性</Text>
                        </Col>
                        <Col span={14} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={format('toString', data.coPossibilityId)}
                                onChange={value => handleChange(value, 'coPossibilityId')}
                            >
                                {coPossibilityOption}
                            </Select>
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk colon>CO原因</Text>
                        </Col>
                        <Col span={14} offset={1}>
                            <Select
                                mode="multiple"
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={data.coReasonIds}
                                onChange={value => handleChange(value, 'coReasonIds')}
                            >
                                {coReasonOption}
                            </Select>
                        </Col>
                    </Col>
                    {
                       data.coReasonIds && data.coReasonIds.includes('12') &&
                       <Col span={12}>
                           <Col span={8}>
                               <Text asterisk colon>CO原因备注</Text>
                           </Col>
                           <Col span={14} offset={1}>
                               <Input
                                   allowClear
                                   placeholder="请输入"
                                   style={{ width }}
                                   value={data.coReasonRemark}
                                   onChange={e => handleChange(e.target.value, 'coReasonRemark')}
                               />
                           </Col>
                       </Col>
                    }
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk colon>CO中已发生工作占比</Text>
                        </Col>
                        <Col span={13} offset={1}>
                            <InputNumber
                                allowClear
                                placeholder="请输入"
                                style={{ width }}
                                value={data.coHappenedPercent}
                                precision={2}
                                max={100}
                                onChange={value => handleChange(value, 'coHappenedPercent')}
                            />
                        </Col>
                        <Col span={1}>%</Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk colon>CO中未来工作占比</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { (data.coFuturePercent || data.coFuturePercent == 0) ? `${data.coFuturePercent}%` : '' }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk colon>客户是否认同可CO</Text>
                        </Col>
                        <Col span={14} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={format('toString', data.customerAgreeCo)}
                                onChange={value => handleChange(value, 'customerAgreeCo')}
                            >
                                <Option key="1">是</Option>
                                <Option key="0">否</Option>
                            </Select>
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk colon>CO金额是否已达成一致</Text>
                        </Col>
                        <Col span={14} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={format('toString', data.coAmountAgreement)}
                                onChange={value => handleChange(value, 'coAmountAgreement')}
                            >
                                <Option key="1">是</Option>
                                <Option key="0">否</Option>
                            </Select>
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>是否有折扣</Text>
                        </Col>
                        <Col span={14} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={format('toString', data.haveDiscount)}
                                onChange={value => handleChange(value, 'haveDiscount')}
                            >
                                <Option key="1">是</Option>
                                <Option key="0">否</Option>
                            </Select>
                        </Col>
                    </Col>
                    {
                        data.haveDiscount == '1' &&
                        <Col span={12}>
                            <Col span={8}>
                                <Text asterisk colon>折扣比例</Text>
                            </Col>
                            <Col span={13} offset={1}>
                                <InputNumber
                                    allowClear
                                    placeholder="请输入"
                                    style={{ width }}
                                    value={data.discountPercent}
                                    precision={2}
                                    onChange={value => handleChange(value, 'discountPercent')}
                                />
                            </Col>
                            <Col span={1}>%</Col>
                        </Col>
                    }

                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>实际CO金额含税/人民币</Text>
                        </Col>
                        <Col span={13} offset={1}>
                            <InputNumber
                                allowClear
                                placeholder="请输入"
                                style={{ width }}
                                value={data.actualAmount}
                                precision={2}
                                onChange={value => handleChange(value, 'actualAmount')}
                            />
                        </Col>
                        <Col span={1}>元</Col>
                    </Col>
                    {
                        data.coAmountAgreement == '1' &&
                        <Col span={12}>
                            <Col span={8}>
                                <Text asterisk colon>是否CO定稿</Text>
                            </Col>
                            <Col span={14} offset={1}>
                                <Select
                                    allowClear
                                    placeholder="请选择"
                                    style={{ width }}
                                    value={format('toString', data.coFinalization)}
                                    onChange={value => handleChange(value, 'coFinalization')}
                                >
                                    <Option key="1">是</Option>
                                    <Option key="0">否</Option>
                                </Select>
                            </Col>
                        </Col>
                    }
                    {
                        data.coFinalization == '1' &&
                        <Col span={12}>
                            <Col span={8}>
                                <Text asterisk colon>是否已在签署流程</Text>
                            </Col>
                            <Col span={14} offset={1}>
                                <Select
                                    allowClear
                                    placeholder="请选择"
                                    style={{ width }}
                                    value={format('toString', data.coIsSigningProcess)}
                                    onChange={value => handleChange(value, 'coIsSigningProcess')}
                                >
                                    <Option key="1">是</Option>
                                    <Option key="0">否</Option>
                                </Select>
                            </Col>
                        </Col>
                    }
                    {
                        data.coIsSigningProcess == '1' &&
                        <Col span={12}>
                            <Col span={8}>
                                <Text asterisk colon>签署节点</Text>
                            </Col>
                            <Col span={14} offset={1}>
                                <Input
                                    allowClear
                                    placeholder="请输入"
                                    style={{ width }}
                                    value={data.signingNode}
                                    onChange={e => handleChange(e.target.value, 'signingNode')}
                                />
                            </Col>
                        </Col>
                    }
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk colon>预计签署完成日期</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <DatePicker
                                style={{ width }}
                                allowClear
                                disabled={data.actualSignCompletedDate}
                                placeholder="请选择"
                                value={format('toMoment', data.planSignCompletedDate)}
                                onChange={(date, dateString) => handleChange(dateString, 'planSignCompletedDate')}
                            />
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>实际签署完成日期</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <DatePicker
                                style={{ width }}
                                allowClear
                                placeholder="请选择"
                                value={format('toMoment', data.actualSignCompletedDate)}
                                onChange={(date, dateString) => handleChange(dateString, 'actualSignCompletedDate')}
                            />
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon>CO回来当月的原累计完工%</Text>
                        </Col>
                        <Col span={14} offset={1}>
                            {invInfo.coCurrentMonthPercentStr}
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8} style={{ lineHeight: '16px' }}>
                            <Text asterisk={data.coAmountAgreement == '1'} colon>CO回来入账后PM对项目完工百分比预估%</Text>
                        </Col>
                        <Col span={13} offset={1}>
                            <InputNumber
                                allowClear
                                placeholder="请输入"
                                style={{ width }}
                                value={data.coBackPmFinishPercent}
                                precision={2}
                                onChange={value => handleChange(value, 'coBackPmFinishPercent')}
                            />
                        </Col>
                        <Col span={1}>%</Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8} style={{ lineHeight: '16px' }}>
                            <Text colon>CO回来入账后整个项目的项目完工百分比预估</Text>
                        </Col>
                        <Col span={14} offset={1}>
                            {`${data.coInAccountPlanPercent || 0}%`}
                            {/* <InputNumber
                                    allowClear={true}
                                    placeholder="请输入"
                                    style={{width}}
                                    value={data.coInAccountPlanPercent}
                                    precision = {2}
                                    onChange={value => handleChange(value, 'coInAccountPlanPercent')}
                                /> */}
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8} style={{ lineHeight: '16px' }}>
                            <Text colon>CO回来后 ，该CO当月预估可确认收入/人民币(元)</Text>
                        </Col>
                        <Col span={14} offset={1}>
                            {format('money', data.coBackMonthPlanAmount)}
                        </Col>
                    </Col>
                    {
                        data.coIsSigningProcess == '1' &&
                        <Col span={12}>
                            <Col span={8}>
                                <Text asterisk colon>CO是否已上传CTMS</Text>
                            </Col>
                            <Col span={14} offset={1}>
                                <Select
                                    allowClear
                                    placeholder="请选择"
                                    style={{ width }}
                                    value={format('toString', data.coUploadCtms)}
                                    onChange={value => handleChange(value, 'coUploadCtms')}
                                >
                                    <Option key="1">是</Option>
                                    <Option key="0">否</Option>
                                </Select>
                            </Col>
                        </Col>
                    }
                    <Col span={24} style={{ marginBottom: 10, marginTop: 10 }}>
                        <Col span={4} style={{ lineHeight: '16px' }}>
                            <Text asterisk colon>最近跟进进度（前面进度罗列）</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            <TextArea
                                style={{ width: longWidth - 10 }}
                                allowClear
                                value={data.processContent}
                                placeholder="请输入"
                                autosize={{ minRows: 3 }}
                                onChange={e => handleChange(e.target.value, 'processContent')}
                            />
                        </Col>
                    </Col>
                    <Col span={24} style={{ marginBottom: 10 }}>
                        <Col span={4}>
                            <Text asterisk colon>卡脖子关键环节</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={format('toString', data.keyBlocking)}
                                onChange={value => handleChange(value, 'keyBlocking')}
                            >
                                <Option key="客户">客户</Option>
                                <Option key="医院">医院</Option>
                                <Option key="BA">BA</Option>
                                <Option key="津石PM">津石PM</Option>
                                <Option key="NA">NA</Option>
                            </Select>
                        </Col>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

UpdateView.contextTypes = {
    configure: PropTypes.object,
};

export default UpdateView;



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/components/CoUpdateView.js